module.exports = __webpack_public_path__ + "static/lemonade-goes-nationwide-6caecc4869ba678a8f9ca60c587a3650.mp4";